import React from "react";
import PropTypes from "prop-types";
import * as classes from "./CalendarSection.module.css";
import { InlineWidget } from "react-calendly";

const CalendarSection = ({ title, url }) => {
  return (
    <div className={classes.calendarSection}>
      <h2>{title}</h2>
      <InlineWidget
        styles={{
          height: "660px"
        }}
        url={url}
      />
    </div>
  );
};

CalendarSection.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

export default CalendarSection;
